import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import { c as createInjector } from './browser-ac904bdc.js';

const MdDivider = {
  name: "md-divider"
};

const __vue_script__ = MdDivider;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('hr', {
    staticClass: "md-divider"
  });
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-2fcaf473_0", {
    source: ".md-divider{height:1px;margin:0;padding:0;display:block;border:0;background-color:rgba(255,255,255,.38)}.md-divider.md-inset{margin-left:72px}",
    map: undefined,
    media: undefined
  });
};
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);

export { __vue_component__ as default };
